<template>
  <div class="box">
    <my-title size="6">Account items</my-title>

    <table class="table is-striped">
      <tbody>
        <tr v-for="item in myItems" :key="item.id">
          <td>{{ item.name }}</td>
          <!-- <td class="is-narrow"><a @click="revoke(item.id)">Intrekken</a></td> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import MyTitle from '@/components/modules/Title'

export default {
  props: [
    'userId',
    'myItems'
  ],
  components: {
    MyTitle
  },
  methods: {
    revoke (itemId) {
      this.$store.dispatch('items/revoke', {
        itemId: itemId,
        userId: this.userId
      })
    }
  }
}
</script>
